'use client';

import { c as _c } from "react/compiler-runtime";
import { type PinnedFactiii } from '@shared/all/domains/factiiis';
import AuthWidgetContext from '@shared/utils/context/AuthWidgetContext';
import useUser from '@shared/utils/hooks/useUser';
import type { ReactNode } from 'react';
import { useContext, useEffect, useState } from 'react';
import Avatar from '../common/Avatar';
import { NewPostModal } from './NewPost/NewPostModal';
type Props = {
  spaceSlug?: string;
  pinnedFactiii?: PinnedFactiii;
  uniqueId?: string;
  forceModalOpen?: boolean;
  rightAction?: ReactNode;
  disableNewPost?: boolean;
};
const NewPost = props => {
  const $ = _c(39);
  const {
    currentUser
  } = useUser();
  const [newPostModalOpen, setNewPostModalOpen] = useState(false);
  const {
    openAuthContinueModal
  } = useContext(AuthWidgetContext);
  let t0;
  if ($[0] !== currentUser.isAuthenticated || $[1] !== openAuthContinueModal || $[2] !== props.disableNewPost) {
    t0 = () => {
      if (props.disableNewPost) {
        return;
      }
      if (!currentUser.isAuthenticated) {
        return openAuthContinueModal();
      }
      setNewPostModalOpen(true);
    };
    $[0] = currentUser.isAuthenticated;
    $[1] = openAuthContinueModal;
    $[2] = props.disableNewPost;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const openModalHandler = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setNewPostModalOpen(false);
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const closeHandler = t1;
  let t2;
  let t3;
  if ($[5] !== props.forceModalOpen) {
    t2 = () => {
      if (props.forceModalOpen) {
        setNewPostModalOpen(true);
      }
    };
    t3 = [props.forceModalOpen];
    $[5] = props.forceModalOpen;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  const t4 = `${props.disableNewPost ? "cursor-not-allowed opacity-50" : ""}`;
  const t5 = currentUser.avatarKey ?? null;
  const t6 = currentUser.robohash ?? "";
  const t7 = currentUser.tag === "BOT";
  let t8;
  if ($[8] !== currentUser.id || $[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <Avatar avatarKey={t5} robohash={t6} isBot={t7} size={52} userId={currentUser.id} />;
    $[8] = currentUser.id;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className={t4}>{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `flex-1 rounded-3xl bg-background-secondary px-4 py-4 ${props.disableNewPost ? "cursor-not-allowed opacity-50" : "cursor-text"}`;
  const t11 = props.pinnedFactiii ? `Add a ${props.pinnedFactiii.name} post` : "Join the conversation...";
  let t12;
  if ($[16] !== t11) {
    t12 = <p className="text-sm text-textSecondary">{t11}</p>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <div className={t10}>{t12}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== openModalHandler || $[22] !== t13 || $[23] !== t9) {
    t14 = <div data-id="social-compose" className="flex flex-1 cursor-pointer items-center gap-3" onClick={openModalHandler}>{t9}{t13}</div>;
    $[21] = openModalHandler;
    $[22] = t13;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== props.rightAction) {
    t15 = <div className="rounded-xl bg-background-secondary p-2">{props.rightAction}</div>;
    $[25] = props.rightAction;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div className="flex items-center gap-3 rounded-lg border border-ds-border-subtle bg-background-light p-2 md:mx-0">{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== currentUser.isAuthenticated || $[31] !== newPostModalOpen || $[32] !== props.pinnedFactiii || $[33] !== props.spaceSlug || $[34] !== props.uniqueId) {
    t17 = currentUser.isAuthenticated && newPostModalOpen && <NewPostModal closeHandler={closeHandler} spaceSlug={props.spaceSlug} pinnedFactiii={props.pinnedFactiii} uniqueId={props.uniqueId} />;
    $[30] = currentUser.isAuthenticated;
    $[31] = newPostModalOpen;
    $[32] = props.pinnedFactiii;
    $[33] = props.spaceSlug;
    $[34] = props.uniqueId;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};
export default NewPost;